import type { CoachTopic } from '../types/coach';
import { resultCatalog } from '../results/catalog';

export const MAIN_TOPIC: CoachTopic = { kind: 'main' };

/** The topic as it travels in URLs and requests: "main", "result:hogwarts", "person:<edge id>". */
export const coachTopicKey = (topic: CoachTopic) =>
  topic.kind === 'main' ? 'main' : `${topic.kind}:${topic.id}`;

export function parseCoachTopic(value: string | null | undefined): CoachTopic | null {
  if (!value || value === 'main') return MAIN_TOPIC;
  const separator = value.indexOf(':');
  const kind = value.slice(0, separator);
  const id = value.slice(separator + 1);
  if (kind === 'result') {
    const result = resultCatalog.find((item) => item.id === id);
    return result ? { kind, id: result.id } : null;
  }
  if (kind === 'person' && /^[\w.-]{1,128}$/.test(id)) return { kind, id };
  return null;
}
